import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const SliderPaneComponent = ({
  isPaneOpen,
  header,
  onRequestClose,
  children,
  bodyClassName,
}: any) => {
  const { screen }: any = useWindowSize();
  return (
    <div>
      <Offcanvas
        backdrop={true}
        className={["xs", "sm", "md"].includes(screen) ? "w-100" : "w-50"}
        isOpen={isPaneOpen}
        direction="end"
        toggle={onRequestClose}
      >
        {header ? (
          <OffcanvasHeader className="w-100">{header}</OffcanvasHeader>
        ) : null}

        <OffcanvasBody className={bodyClassName ? bodyClassName : ""}>
          {children}
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};
export default SliderPaneComponent;
